import { render } from "./UserApp.vue?vue&type=template&id=458134d4&scoped=true"
import script from "./UserApp.vue?vue&type=script&lang=js"
export * from "./UserApp.vue?vue&type=script&lang=js"

import "./UserApp.vue?vue&type=style&index=0&id=458134d4&lang=scss&scoped=true"
import "./UserApp.vue?vue&type=style&index=1&id=458134d4&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458134d4"]])

export default __exports__